<template>
  <div id="app">
    <router-view />
    <!-- <i class="iconfont icon-rcd-home-f"></i>
    <i class="iconfont icon-chongzhijiaofei"></i> -->
    <tabbar v-show="tabbarType"></tabbar>
    <Loading v-if="loadingType" />
  </div>
</template>
<script>
import tabbar from './components/tabbar.vue'
import Loading from "@/components/Loading.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      active: '',
      tabbarType: true
    }
  },
  components: {
    Loading,
    tabbar
  },
  created() {
    this.$http.getServe();
    this.$store.commit('SET_LOADING', false);
    if (this.$route.name === 'home' || this.$route.name === 'order' || this.$route.name === 'goOrder' || this.$route.name === 'user') {
      this.tabbarType = true;
    } else {
      this.tabbarType = false;
    }
    // 获取用户信息
    if (localStorage.getItem('token')) {
      this.$http.getmyindex().then(res => {
        if (res.code !== -1) {
          this.userInfo = res.data?.info;
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
        }
      });
    }
  },
  computed: {
    ...mapState(['loadingType'])
  },
  methods: {},
  watch: {
    '$route.path'(to, from) {
      // 获取用户信息
      if (localStorage.getItem('token')) {
        console.log('JIUAZA--------------');

        this.$http.getmyindex().then(res => {
          if (res.code !== -1) {
            this.userInfo = res.data?.info;
            localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
          }
        });
      }
      if (to === '/home' || to === '/order' || to === '/goOrder' || to === '/user' || to === '/') {
        this.tabbarType = true;
        console.log('watch', to);
      } else {
        this.tabbarType = false;
        console.log('watch', to);
      }
    }
  }
}
</script>
<style lang="less">
#app {
  //font-family: Rubik-Medium, Rubik;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  background-color: #333;
  min-height: 100vh;
}

div {
  font-size: .4267rem;
  box-sizing: border-box;
}

::v-deep {
  .van-toast__text {
    font-size: .42rem !important;
  }

  .van-toast {
    background-color: #43a8ff !important;
    font-size: .42rem !important;
  }
}

// 全局背景
.cont_bg {
  background:
    linear-gradient(rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)),
    url("./assets/image/JP-en-20260504-TRIFECTA-perspective_589400b2-b44d-47f2-9ea8-821a4e6de483_small.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.van-nav-bar {
  color: #fff;
  height: 100%;
  // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
  background-color: #121212 !important;

  .van-nav-bar__content {
    height: 100%;

    .van-ellipsis {
      overflow: inherit;
    }
  }
}
</style>
